import { useEffect } from "react";
import { useCreate, useList, useNavigation, useUpdate } from "@refinedev/core";
import { Show } from "@refinedev/antd";
import { Button, DatePicker, Form, Input, message } from "antd";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { AppTitle } from "components";
import { MedicineDigest, MedicineDigestFormValues } from "./types";

const DATE_FORMAT = "YYYY-MM-DD";

export const MedicineDigestFormPage = () => {
  const { push } = useNavigation();
  const params = useParams();
  const digestId = params.id ? Number(params.id) : undefined;
  const isEdit = Boolean(digestId);
  const [form] = Form.useForm<MedicineDigestFormValues>();

  const { data, isLoading } = useList<MedicineDigest>({
    resource: "medicine-digests",
    dataProviderName: "medicineDigestsDataProvider",
    queryOptions: {
      enabled: isEdit,
    },
  });
  const { mutate: createDigest, isLoading: creatingDigest } = useCreate();
  const { mutate: updateDigest, isLoading: updatingDigest } = useUpdate();

  useEffect(() => {
    const digest = data?.data.find((item) => item.id === digestId);

    if (!digest) {
      return;
    }

    form.setFieldsValue({
      id: digest.id,
      title: digest.title,
      text: digest.text,
      date: dayjs(digest.date, DATE_FORMAT) as any,
    });
  }, [data?.data, digestId, form]);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    const payload = {
      ...values,
      id: isEdit ? digestId : null,
      date: dayjs(values.date).format(DATE_FORMAT),
    };
    const callbacks = {
      onSuccess: () => {
        message.success("Дайджест сохранен");
        push("/medicine/materials");
      },
      onError: (error: any) => {
        message.error(error?.message || "Не удалось сохранить дайджест");
      },
    };

    if (isEdit && digestId) {
      updateDigest(
        {
          dataProviderName: "medicineDigestsDataProvider",
          resource: "medicine-digests",
          id: digestId,
          values: payload,
        },
        callbacks
      );
      return;
    }

    createDigest(
      {
        dataProviderName: "medicineDigestsDataProvider",
        resource: "medicine-digests",
        values: payload,
      },
      callbacks
    );
  };

  return (
    <Show
      isLoading={isLoading}
      title={
        <AppTitle canGoBack>
          {isEdit ? "Редактирование дайджеста" : "Создание дайджеста"}
        </AppTitle>
      }
      breadcrumb={false}
      headerButtons={<></>}
      footerButtons={null}
      goBack={false}
    >
      <Form<MedicineDigestFormValues> form={form} layout="vertical">
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>

        <Form.Item
          name="title"
          label="Название"
          rules={[{ required: true, message: "Введите название" }]}
        >
          <Input placeholder="Дайджест №30" />
        </Form.Item>

        <Form.Item
          name="date"
          label="Дата"
          rules={[{ required: true, message: "Выберите дату" }]}
        >
          <DatePicker format={DATE_FORMAT} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="text"
          label="Текст"
          rules={[{ required: true, message: "Введите текст" }]}
        >
          <Input.TextArea
            rows={10}
            placeholder="Список тем и краткое содержание..."
          />
        </Form.Item>

        <Button
          type="primary"
          loading={creatingDigest || updatingDigest}
          onClick={handleSubmit}
        >
          Сохранить
        </Button>
      </Form>
    </Show>
  );
};
